module.exports = __webpack_public_path__ + "img/right_tc_new.8e82f22c.png";